import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Conversation } from "../components/common/ConversationItem";
import { VIRTUAL_CONVERSATION_ID } from "../constants";

export const useShowConversation = (id?: string) => {
  const fetchConversation = () =>
    reactQueryGet<Conversation>(
      internalApi.helpWidget.showConversation({ id }),
    );

  return useQuery(["help-widget", "conversations", id], fetchConversation, {
    enabled: Boolean(id) && id !== VIRTUAL_CONVERSATION_ID,
  });
};
